<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item @click.native="gohome"><a>首页</a></el-breadcrumb-item>
      <el-breadcrumb-item>补充医疗业务办理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 步骤一：填写基本信息 -->
    <el-card class="apply-card step-one" v-show="steponeShow">
      <div class="card-header">
        <div class="header-content">
          <i class="el-icon-document header-icon"></i>
          <h2 class="header-title">补充医疗业务办理</h2>
        </div>
        <div class="progress-status">
          <el-tag type="primary" size="small">步骤 1/3</el-tag>
        </div>
      </div>
      <!-- 步骤条 -->
      <el-steps :active="1" align-center class="custom-steps">
        <el-step title="填写基本信息" icon="el-icon-edit" description="选择缴费标准并确认人数"></el-step>
        <el-step title="上传人员信息" icon="el-icon-upload" description="上传Excel人员名单"></el-step>
        <el-step title="完成提交" icon="el-icon-check" description="确认并提交申请"></el-step>
      </el-steps>
      <!-- 提示信息 -->
      <el-alert
          title="重要提示：补充医疗提交人员名单必须与本单位基本医疗系统保持一致，非本单位职工不予报销。"
          type="warning" :closable="false" show-icon class="notice-alert"
      />
      <!-- 基本信息表单 -->
      <div class="basic-info-form">
        <div class="info-section">
          <h3 class="section-title"><i class="el-icon-office-building"></i>单位参保缴费信息</h3>
          <el-row :gutter="20" class="info-grid">
            <el-col :span="12" class="info-item" style="display: flex;">
              <div class="info-label">单位编号：</div>
              <div >{{ user.aab001 }}</div>
            </el-col>
            <el-col :span="12" class="info-item" style="display: flex;">
              <div class="info-label">单位名称：</div>
              <div >{{ user.aab002 }}</div>
            </el-col>
            <el-col :span="12" class="info-item" style="display: flex;">
              <div class="info-label">缴费期限：</div>
              <div >{{ piccnew.timeaction }} 至 {{ piccnew.timeend }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="info-grid">
            <el-col :span="24" class="info-item">
              <div class="premium-options">
                <el-radio-group v-model="user.bcylfl" @change="getbxblChange" class="premium-radio-group">
                  <div v-for="item in JSON.parse(user.column3)" :key="item.id" class="premium-option">
                    <el-radio :label="item.id" class="custom-radio">
                      <div class="option-content">
                        <span class="option-amount">{{ item.text }} 元/人/年</span>
                        <span class="option-tip">缴费标准</span>
                      </div>
                    </el-radio>
                  </div>
                </el-radio-group>
                <div v-if="!user.bcylfl" class="select-prompt">
                  <i class="el-icon-warning"></i>
                  请选择缴费标准
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 参保人数输入 -->
          <div class="personnel-section">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="number-input-group">
                  <div class="input-label">
                    <i class="el-icon-user"></i>
                    在职参保人数
                  </div>
                  <el-input-number v-model="piccnew.zznum" @change="getspacee(piccnew.zznum)" :min="0"  label="在职参保人数" style="width:100%"></el-input-number>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="number-input-group">
                  <div class="input-label">
                    <i class="el-icon-user-solid"></i>
                    退休参保人数
                  </div>
                  <el-input-number v-model="piccnew.txnum" @change="getspacee(piccnew.txnum)" :min="0"  label="退休参保人数" style="width:100%"></el-input-number>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- 计算结果 -->
          <div class="calculation-results">
            <div class="result-card">
              <div class="result-header">
                <i class="el-icon-calculator"></i>
                计算结果
              </div>
              <div class="amount-breakdown">
                <div class="breakdown-item">
                  <span>在职：{{ piccnew.zznum }} 人 × {{ piccnew.bxbl }} 元</span>
                  <span class="breakdown-amount">¥ {{ piccnew.zznum * piccnew.bxbl }}</span>
                </div>
                <div class="breakdown-item">
                  <span>退休：{{ piccnew.txnum }} 人 × {{ piccnew.bxbl }} 元</span>
                  <span class="breakdown-amount">¥ {{ piccnew.txnum * piccnew.bxbl }}</span>
                </div>
              </div>
              <div class="amount-breakdown">
                <el-row :gutter="20" class="result-grid">
                  <el-col :span="12">
                    <div class="result-item">
                      <div class="result-label">总参保人数</div>
                      <div class="result-value total-person">{{ piccnew.num }}</div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="result-item">
                      <div class="result-label">应缴金额</div>
                        <div class="result-value total-amount">
                          ¥ {{ formatAmount(piccnew.spacec) }}
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <!-- 操作按钮 -->
            <div class="action-buttons">
              <el-button
                  type="primary"
                  @click="stepOne"
                  class="next-step-btn"
                  size="large"
              >
                <i class="el-icon-arrow-right"></i>
                下一步：上传人员名单
              </el-button>
            </div>
          </div>
        </div>
    </el-card>
    <!-- 卡片视图区 步骤一 -->
    <el-card id="card_st" v-show="yjblShow">
      <el-alert title="提示：补充医疗提交人员名单要与本单位基本医疗系统一致，非本单位职工不予报销。" type="error" style="margin-bottom: 10px;"></el-alert>
      <div style="padding-top: 10px;text-align: center;">
        <span style="color: red;">已申请!请点击受理记录查看</span>
      </div>
    </el-card>
    <el-card id="card_st" v-show="steptwoShow">
      <el-steps :active="2">
        <el-step title="填写基本信息" icon="el-icon-edit">

        </el-step>
        <el-step title="上传人员名单" icon="el-icon-upload"></el-step>
        <el-step title="完成" icon="el-icon-picture"></el-step>
      </el-steps>
      <el-alert title="提示：补充医疗提交人员名单要与本单位基本医疗系统一致，非本单位职工不予报销。" type="error" style="margin-bottom: 10px;"></el-alert>
      <input ref="file" type="file" accept=".xlsx,.xls" style="display: none;" @change="uploadFile">
      <el-button type="primary" icon="el-icon-upload" v-loading.fullscreen.lock="fullscreenLoading" @click="clickFile">
        上传人员名单
      </el-button>
      <el-button class="rymdmb" type="success1" @click="downloadMb">下载人员名单模板</el-button>
      <el-button type="warning" @click="uploadHelp = true">上传文件帮助</el-button>
      <el-button type="danger" icon="el-icon-delete" @click="deleteFile(user.aab001)" v-if="deleteshow">清空人员名单
      </el-button>
      <el-button type="success" icon="el-icon-top" @click="txjbxx">返回上级</el-button>

      <el-alert :title="alert_1"  type="warning" effect="dark" :closable="false" center show-icon></el-alert>
      <div class="tag-group" style="margin-top: 15px;">
        <el-tag
            key="上传人员成功列表"
            type="success"
            effect="plain">
          上传人员成功列表
        </el-tag>
      </div>
      <!-- 用户列表 -->
      <el-table  v-loading="loadingredisPage" :data="redisPagelist" border stripe value-format="timestamp" :header-cell-style="thStyleFun"
                 :cell-style="cellStyleFun">
        <el-table-column label="序号" prop="" width="180" align="center">
          <template slot-scope="scope">
            <span v-text="getIndex(scope.$index)"> </span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="aac003"></el-table-column>
        <el-table-column label="身份证号" prop="aac002"></el-table-column>
        <el-table-column label="工作状态" prop="spaced"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="danger" icon="el-icon-delete" size="mini"
                       @click="deleteRedisPageList(scope.row.spaced)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="queryInfo.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      <el-alert :title="alert_success" v-show="showfilelist" :closable="false" center type="success" show-icon >
      </el-alert>
      <el-alert :title="alert_error" v-show="showfilelist" :closable="false" center type="error" show-icon >
      </el-alert>
      <!-- 上传失败列表 -->
      <div class="tag-group" style="margin-top: 15px;" v-show="showfilelist">
        <el-tag key="上传人员成功列表" type="danger" effect="plain">
          上传人员失败列表
        </el-tag>
      </div>
      <el-table :data="errorlist" v-show="showfilelist" style="color: red;" border stripe value-format="timestamp"
                :header-cell-style="thStyleFun" :cell-style="cellStyleFun">
        <el-table-column label="序号" prop="" width="180" align="center">
          <template slot-scope="scope">
            <span v-text="getIndex(scope.$index)"> </span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="aac003"></el-table-column>
        <el-table-column label="身份证号" prop="aac002"></el-table-column>
        <el-table-column label="错误提示" prop="spaced"></el-table-column>
      </el-table>
      <div style="text-align: center;">
        <el-button type="primary" style="width: 200px;margin-top: 20px;" @click="insertfile">确定</el-button>
      </div>

    </el-card>
    <el-dialog title="单位信息维护" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
               :visible.sync="dialogFormVisible">
      <el-form :model="updateuser" ref="updateuser" label-width="110px" :rules="updateuserRules" class="demo-ruleForm"
               style="text-align: center;">
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="单位编号" prop="aab001">
              <el-col :span="24">
                <el-input v-model="updateuser.aab001" :disabled="true" placeholder="请输入单位编号"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="单位名称" prop="aab002">
              <el-col :span="24">
                <el-input v-model="updateuser.aab002" placeholder="请输入单位名称"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="单位地址" prop="address">
              <el-col :span="24">
                <el-input v-model="updateuser.address" placeholder="请输入单位地址"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="联系人姓名" prop="lxrname">
              <el-col :span="24">
                <el-input v-model="updateuser.lxrname" placeholder="请输入联系人姓名"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="联系人电话" prop="lxrphone">
              <el-col :span="24">
                <el-input v-model="updateuser.lxrphone" placeholder="请输入联系人电话"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="邮箱" prop="lxremail">
              <el-col :span="24">
                <el-input v-model="updateuser.lxremail" placeholder="请输入邮箱"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <!--        <el-row :gutter="20">-->
        <!--            <el-col :span="18" :offset="2">-->
        <!--                <el-form-item label="行业类型">-->
        <!--                    <el-col :span="6" style="text-align: left;">-->
        <!--                        <el-button :type="buttontype" @click="innerVisible = true">{{buttonstate}}</el-button>-->

        <!--                    </el-col>-->
        <!--                    <el-col :span="18" style="text-align: left;" prop="column1">-->
        <!--                        <span>{{updateuser.column1}}</span>-->
        <!--                    </el-col>-->
        <!--                </el-form-item>-->
        <!--            </el-col>-->
        <!--        </el-row>-->
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="统一信用代码" prop="snumber">
              <el-col :span="24">
                <el-input v-model="updateuser.snumber" placeholder="请输入统一信用代码"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="法人代表" prop="headuser">
              <el-col :span="24">
                <el-input v-model="updateuser.headuser" placeholder="请输入法人代表"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="18" :offset="2">
            <el-form-item label="注册所在区" prop="dsfj">
              <el-col :span="24" style="text-align: left;">
                <el-select v-model="updateuser.dsfj" placeholder="请选择">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>

            </el-form-item>
          </el-col>
        </el-row>


      </el-form>
      <div style="text-align: center;">
        <el-button type="primary" @click="submitForm('updateuser')">确定修改</el-button>
        <!-- <el-button @click="resetForm('updateuser')">重置</el-button> -->
      </div>
      <el-dialog width="50%" title="请选择行业类型" :visible.sync="innerVisible" append-to-body>
        <el-table ref="multipleTable" :data="tableData" :show-overflow-tooltip='true' tooltip-effect="dark"
                  style="width: 100%">
          <el-table-column width="60">
            <template slot-scope="scope">
              <el-radio :label="scope.$index" v-model="usertype"
                        @change.native="getTemplateRow(scope.$index,scope.row)">&nbsp;
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="hylb" width="80" label="行业类别">
          </el-table-column>
          <el-table-column prop="fy" label="缴费标准" width="140">
          </el-table-column>
          <el-table-column prop="ejfl" label="二级分类" width="80">
          </el-table-column>
          <el-table-column prop="hymc" label="行业名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="baserate" label="基准费率(%)" width="90">
          </el-table-column>

        </el-table>
        <div style="padding-top: 10px;text-align: center;">
          <el-button type="primary" @click="gethylb">确定</el-button>
        </div>
      </el-dialog>

    </el-dialog>
    <el-dialog title="上传文件帮助" class=”pub_dialog”>
      1.错误格式，复制进去的或其他方式的错误格式信息<br>
      <img src="https://wps-jiewennet.oss-cn-beijing.aliyuncs.com/file/1.png"><br> 2.错误格式进行调整
      <br>
      <img src="https://wps-jiewennet.oss-cn-beijing.aliyuncs.com/file/2.png"><br> 3.调整成功，可上传
      <br>
      <img src="https://wps-jiewennet.oss-cn-beijing.aliyuncs.com/file/3.png"><br> 4.另存为xls格式
      <br>
      <img src="https://wps-jiewennet.oss-cn-beijing.aliyuncs.com/file/4.png"><br>
    </el-dialog>
    <el-dialog width="50%" title="请选择补充医疗报销比例类型" :visible.sync="ylbxblVisible" append-to-body>
      <!--      <el-table ref="multipleTable" :data="ylbxlxData" :show-overflow-tooltip='true' tooltip-effect="dark"-->
      <!--                style="width: 100%">-->
      <!--        <el-table-column width="60">-->
      <!--          <template slot-scope="scope">-->
      <!--            <el-radio :label="scope.$index" v-model="usertype" @change.native="geylbxblRow(scope.$index,scope.row)">-->
      <!--              &nbsp;-->
      <!--            </el-radio>-->
      <!--          </template>-->
      <!--        </el-table-column>-->
      <!--        <el-table-column prop="bxbl" label="缴费标准">-->
      <!--        </el-table-column>-->
      <!--        <el-table-column prop="fy" label="保险期限">-->
      <!--        </el-table-column>-->
      <!--      </el-table>-->
      <el-card class="jfjs">
        <el-radio-group v-model="user.bcylfl" @change="getbxblChange">
          <el-radio v-for="item in JSON.parse(user.column3)" :key="item.id" :label="item.id">
            缴费标准： {{ item.text }} 元/人/年  缴费期限：{{ piccnew.timeaction }}到{{ piccnew.timeend }}
          </el-radio>
        </el-radio-group>
      </el-card>
      <div style="padding-top: 10px;text-align: center;">
        <el-button type="primary" @click="getylbxbl">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from "moment";
export default {
  inject: ['reload'],
  data() {
    //手机号验证
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };
    return {
      user: '',
      // 请求数据
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
      },
      piccnew: {
        aab001: '',
        term: '5',
        timeaction: '',
        timeend: '',
        num: '',
        userstatus: '0',
        spacea: '',
        spaceb: '',
        spacec: '',
        spaced: '',
        spacee: '',
        spacef: '1',
        spaceg: '0',
        zznum: '',
        txnum: '',
        bxbl: ''

      },
      //补充医疗在职人员缴费费用
      zzfy: 0,
      //补充医疗退休人员缴费费用
      txfy: 0,
      //单位信息维护
      dialogFormVisible: false,
      innerVisible: false,
      uploadHelp: false,

      updateuser: {
        aab001: '',
        aab002: '',
        address: '',
        lxrname: '',
        lxrphone: '',
        lxremail: '',
        snumber: '',
        headuser: '',
        dsfj: '',
        usertype: '',
        column1: '',
        rqtime: '',
        raddress: ''

      },
      updateuserRules: {
        aab001: [{
          required: true,
          message: '请输入单位编号',
          trigger: 'blur'
        }, {
          min: 20,
          max: 20,
          message: '长度 20 个字符',
          trigger: 'blur'
        }],
        aab002: [{
          required: true,
          message: '请单位名称',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请单位地址',
          trigger: 'blur'
        }],
        lxrname: [{
          required: true,
          message: '请联系人姓名',
          trigger: 'blur'
        }],
        lxrphone: [{
          message: '请输入手机号',
          required: true,
          trigger: 'blur'
        }],
        lxremail: [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        }, {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: ['blur', 'change']
        }],
        column1: [{
          required: true,
          message: '请选择行业类型',
          trigger: 'change'
        }],
        snumber: [{
          required: true,
          message: '请输入统一信用代码',
          trigger: 'blur'
        }],
        headuser: [{
          required: true,
          message: '请输入法人代表',
          trigger: 'blur'
        }],
        dsfj: [{

          required: true,
          message: '请选择注册所在区',
          trigger: 'change'
        }],

      },
      //单位信息修改时选择行业类型
      buttontype: 'primary',
      buttonstate: '请选择',

      //清空人员名单button展示
      deleteshow: false,
      //请选择补充医疗报销比例类型对话框
      ylbxblVisible: false,

      //补充医疗报销比例
      bcylbxlx: '',
      // ylbxlxData: [{
      //     bxbl: '每人每年260元',
      //     fy: '',
      // },{
      //     bxbl: '每人每年380元',
      //     fy: '',
      // }],

      //上传人员名单等待
      fullscreenLoading: false,
      tableData: [{
        hylb: '一类甲',
        fy: '6元',
        ejfl: '一类甲',
        hymc: '软件和信息技术服务业，货币金融服务，资本市场服务， 保险业， 其他金融业， 科技推广和应用服务业， 社会工作， 广播、 电视、 电影和影视录音制作业， 中国共产党机关， 国家机构， 人民政协、 民主党派， 社会保障， 群众团体、 社会团体和其他成员组织， 基层群众自治组织， 国际组织。 ',
        baserate: '0.3'
      }, {
        hylb: '一类乙',
        fy: '12元',
        ejfl: '一类乙',
        hymc: '批发业，零售业，仓储业，邮政业，住宿业，餐饮业，电信、广播电视和卫星传输服务，互联网和相关服务，房地产业，租赁业，商务服务业，研究和试验发展，专业技术服务业，居民服务业，其他服务业，教育，卫生，新闻和出版业，文化艺术业。',
        baserate: '0.6'
      }, {
        hylb: '二类甲',
        fy: '9元',
        ejfl: '二类甲',
        hymc: '农副食品加工业，食品制造业，酒、饮料和精制茶制造业，烟草制品业，纺织业，木材加工和木、竹、藤、棕、草制品业，文教、工美、体育和娱乐用品制造业，计算机、通信和其他电子设备制造业，仪农副食品加工业，食品制造业，酒、饮料和精制茶制造业，烟草制品业，纺织业，木材加工和木、竹、藤、棕、草制品业，文教、工美、体育和娱乐用品制造业，计算机、通信和其他电子设备制造业，仪器仪表制造业，其他制造业，水的生产和供应业，机动车、电子产品和日用产品修理业，水利管理业，生态保护和环境治理业，公共设施管理业，娱乐业。',
        baserate: '1.05'
      }, {
        hylb: '二类乙',
        fy: '9元',
        ejfl: '二类乙',
        hymc: '农业，畜牧业，农、林、牧、渔服务业，纺织服装、服饰业，皮革、毛皮、羽毛及其制品和制鞋业，印刷和记录媒介复制业，医药制造业，化学纤维制造业，橡胶和塑料制品业，金属制品业，通用设备制造业，专用设备制造业，汽车制造业，铁路、船舶、航空航天和其他运输设备制造业，电气机械和器材制造业，废弃资源综合利用业，金属制品、机械和设备修理业，电力、热力生产和供应业，燃气生产和供应业，铁路运输业，航空运输业，管道运输业，体育。',
        baserate: '1.35'
      }, {
        hylb: '二类丙',
        fy: '9元',
        ejfl: '二类丙',
        hymc: '林业，开采辅助活动，家具制造业，造纸和纸制品业，建筑安装业，建筑装饰和其他建筑业，道路运输业，水上运输业，装卸搬运和运输代理业。',
        baserate: '1.65',
      }, {
        hylb: '三类甲',
        fy: '11元',
        ejfl: '三类甲',
        hymc: '渔业，化学原料和化学制品制造业，非金属矿物制品业，黑色金属冶炼和压延加工业，有色金属冶炼和压延加工业，房屋建筑业，土木工程建筑业。',
        baserate: '1.95'
      }, {
        hylb: '三类乙',
        fy: '11元',
        ejfl: '三类乙',
        hymc: '石油和天然气开采业，其他采矿业，石油加工、炼焦和核燃料加工业。',
        baserate: '2.4'
      }, {
        hylb: '三类丙',
        fy: '11元',
        ejfl: '三类丙',
        hymc: '煤炭开采和洗选业，黑色金属矿采选业，有色金矿采选业，非金属矿采选业。',
        baserate: '2.85'

      }],
      //选择行业类别
      usertype: '',
      //选择注册所在区
      options:  [
        {value:   '01', label:   '盘锦市本级'},
        {value:   '02', label:   '兴隆台区'},
        {value:   '03', label:   '辽东湾'},
        {value:   '04', label:   '双台子区'},
        {value:   '05', label:   '大洼县'},
        {value:   '06', label:   '盘山县'},
        {value:   '07', label:   '油田'},
        {value:   '08', label:   '事业单位'}],

      total: 0,
      //参保步骤展示
      steponeShow: true,
      steptwoShow: false,
      yjblShow: false,

      //展示上传人数成功信息
      showfilelist: false,

      loadingredisPage: false, // 用户列表
      redisPagelist: [], // 用户列表
      errorlist: [], //上传错误列表
      alert_1: '您选择：年缴，参保人数为：人',
      alert_success: '',
      alert_error: '',
      // bcylfl260: false,
      // bcylfl380: false,

      thStyleFun() {
        return 'text-align:center'
      },
      cellStyleFun() {
        return 'text-align:center'
      }
    }

  },
  created() {
    // const piccuser = JSON.parse(window.sessionStorage.getItem("user")); // session取值
    // console.log(JSON.parse(window.sessionStorage.getItem("user")));
    this.user = JSON.parse(window.sessionStorage.getItem("user"));
    window.addEventListener('setItem', () => {
      this.user = JSON.parse(window.sessionStorage.getItem("user"));
    })
    let date = new Date();
    let year = date.getFullYear();
    if(this.user.column3 == "" || this.user.column3 == null) {
      this.user.column3 = '[{"id":1,"text":"260"},{"id":2,"text":"380"}]';
    }
    var bcylflxx = [];
    for (const yearElement of JSON.parse(this.user.column3)) {
      if (this.user.bcylfl == yearElement.id) {
        bcylflxx.push(yearElement)
      }
    }
    if(this.user.bcylfl != null){
      if(this.user.rqtime != null) {
        if (this.user.rqtime.startsWith(year)) {
          if (this.user.bcylfl == 2) {
            this.user.column3 = JSON.stringify(bcylflxx);
          }
        } else {
          //1月分也可以改
          if (date.getMonth() === 0) {

          } else {
            if (this.user.bcylfl == 1) {
              // this.user.column3 = JSON.stringify(bcylflxx);
            } else if (this.user.bcylfl == 2) {
              this.user.column3 = JSON.stringify(bcylflxx);
            }
          }
        }
      }else{
        if (this.user.bcylfl == 1) {
          // this.user.column3 = JSON.stringify(bcylflxx);
        } else if (this.user.bcylfl == 2) {
          this.user.column3 = JSON.stringify(bcylflxx);
        }
      }
    }
    //20241224 lyx add 保险比例
    if( this.user.bcylfl  == undefined){
      this.user.bcylfl = null
    }else{
      this.user.bcylfl = Number(this.user.bcylfl)
      for (const yearElement of JSON.parse(this.user.column3)) {
        if (this.user.bcylfl == yearElement.id) {
          this.piccnew.bxbl= yearElement.text
        }
      }
    }
    //20241224 lyx add 保险比例
    this.updateuser = this.user;
    if (this.updateuser.address != null) {
      // this.usertype = (this.updateuser.usertype.substring(1) - 0) - 1;
    } else {
      this.$message({
        showClose: true,
        message: "请单位信息维护",
        type: 'warning',
        customClass: 'mzindex'
      });
      this.dialogFormVisible = true;
    }
    this.sfbl();
    // this.aab001 = piccuser.aab001;
    // console.log(window.sessionStorage.getItem("user"))
    //js引入
    this.piccnew.aab001 = this.user.aab001;
    this.piccnew.spaced = this.user.lxrname;
    this.piccnew.spacee = this.user.lxrphone;
    this.piccnew.zznum=this.user.zznum == null ? '0' : this.user.zznum;
    this.piccnew.txnum=this.user.txnum == null ? '0' : this.user.txnum;
    this.piccnew.num=Number(this.piccnew.zznum)+ Number(this.piccnew.txnum);
    this.getspacee(this.piccnew.num)
    let moment = require('moment');
    this.piccnew.timeaction = moment().startOf('year').format('YYYY-MM-DD') //下个月初
    this.piccnew.timeend =  moment().endOf('year').format('YYYY-MM-DD') //下个月末
    // this.ylbxlxData[0].fy=this.piccnew.timeaction+"到"+this.piccnew.timeend
    // this.ylbxlxData[1].fy=this.piccnew.timeaction+"到"+this.piccnew.timeend
    // this.bcylbxlx = "";
  },
  methods: {
    stepOne() {
      if(this.piccnew.bxbl === ''){
        return this.$message.error("请选择缴费标准！");
      }
      if (this.piccnew.num == "") {
        this.$message({
          duration: 600,
          type: 'error',
          message: '请输入参保人数！！！'
        });
        return;
      }
      this.steponeShow = !this.steponeShow;
      this.steptwoShow = !this.steptwoShow;
      this.alert_1 = '您选择：年缴，参保人数为：' + this.piccnew.num + '人，在职参保人数为：' + this.piccnew.zznum + '人，退休参保人数为：' + this.piccnew.txnum + '人。缴费标准：'+this.piccnew.bxbl+'元/人/年，共'+this.piccnew.spacec+'元' ;
    },
    clickFile() {
      this.$refs.file.dispatchEvent(new MouseEvent('click'))
    },
    handleExcelSuccess(res, file) {
      // console.log(res, file);
      if (res.msg === "ok") {
        this.$message("上传成功");
        this.getList();
      }
    },
    //redis中获取上传人员名单
    async redisPageList() {
      this.loadingredisPage = true
      // 在$.post()前把ajax设置为同步：$.ajaxSettings.async = false;
      // 在$.post()后把ajax改回为异步：$.ajaxSettings.async = true;
      var formData = new FormData()
      formData.append('pageNum', this.queryInfo.pageNum);
      formData.append('pageSize', this.queryInfo.pageSize);
      formData.append('aab001', "5_"+this.piccnew.aab001 );
      // 调用post请求
      const {
        data: res
      } = await this.$http.post("redisPage", formData, {
        // pageNum: this.queryInfo.pageNum,
        // pageSize: this.queryInfo.pageSize,
        // aab001: this.piccnew.aab001

      }, {

      });
      this.loadingredisPage = false
      this.redisPagelist = res.data; // 将返回数据赋值
      this.total = res.numbers; // 总个数
    },
    // 监听pageSize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.redisPageList(); // 数据发生改变重新申请数据
    },
    // 监听pageNum改变的事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.redisPageList(); // 数据发生改变重新申请数据
    },
    // 导入数据
    uploadFile() {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const file = this.$refs.file.files
      var extName = file[0].name.substring(file[0].name.lastIndexOf('.')).toLowerCase()
      // var username = this.$store.getters.name
      if (extName === '.xlsx' || extName === '.xls') {
        var formData = new FormData()
        formData.append('file', file[0]);
        formData.append('aab001', this.piccnew.aab001);
        formData.append('spacec', this.user.aab002);
        formData.append('spaceb', this.user.dsfj);
        formData.append('num', this.piccnew.num);
        formData.append('zznum', this.piccnew.zznum);
        formData.append('txnum', this.piccnew.txnum);
        var url = "/uploadExcel";
        this.$http.post(url, formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
            .then((res) => {
              loading.close();
              if (res.data.code == '1') {

                this.redisPageList();
                // this.$message.success(res.data.msg);
                this.$notify({
                  title: '成功',
                  message: res.data.msg,
                  type: 'success'
                });
                this.$message({
                  showClose: true,
                  duration: 5000,
                  type: 'success',
                  message: res.data.msg
                });
                // this.errorlist = res.data.errorlist;
                this.showfilelist = true;
                this.alert_success = '上传成功' + res.data.totals + '条';
                // this.alert_error = '上传失败' + 0 + '条';
                // console.log(res);
                this.deleteshow = true;

                this.errorlist = res.data.errorlist;
                this.alert_error = '上传重复' + res.data.errorlist.length + '条';
                // console.log(res);
              }
              if (res.data.code == '-3') {

                this.$message({
                  showClose: true,
                  duration: 8000,
                  type: 'error',
                  message: res.data.msg
                });
                this.redisPageList();
                this.alert_success = '上传成功' + 0 + '条';
                this.alert_error = '上传错误' + res.data.errorlist.length + '条';
                // console.log(res);
                this.deleteshow = true;

              }
              if (res.data.code == '-2') {

                this.$message({
                  showClose: true,
                  duration: 8000,
                  type: 'error',
                  message: res.data.msg
                });
                this.errorlist = res.data.errorlist;
                this.showfilelist = true;
                this.alert_success = '上传成功' + 0 + '条';
                this.alert_error = '上传重复' + res.data.errorlist.length + '条';
                // console.log(res);
                this.deleteshow = true;
              }
              if (res.data.code == '-1') {

                this.$message({
                  showClose: true,
                  duration: 8000,
                  type: 'error',
                  message: res.data.msg
                });
                this.errorlist = res.data.errorlist;
                this.redisPagelist = [];
              }

            }).catch((err) => {

          this.$message({
            showClose: true,
            duration: 8000,
            type: 'error',
            message: '上传失败！！！'
          });

        })
      } else {

        this.$message({
          showClose: true,
          duration: 8000,
          type: 'error',
          message: '上传失败！！！，请选择正确的xlsx模板文件'
        });
      }
      this.$refs.file.value = null;

    },
    //获取表格序号
    getIndex($index) {
      //表格序号
      return (this.queryInfo.pageNum - 1) * this.queryInfo.pageSize + $index + 1
    },
    // 删除按钮
    async deleteRedisPageList(num) {
      // 弹框
      const confirmResult = await this.$confirm('删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      // 成功删除为confirm 取消为 cancel
      if (confirmResult != 'confirm') {
        return this.$message.info("已取消删除");
      }
      const {
        data: res
      } = await this.$http.get("deletRedisPageList?num=" + num + "&aab001=5_" + this.user.aab001 );
      if (res != "success") {
        return this.$message.error("删除失败！！！");
      }
      this.$message.success("已删除！！！");
      this.redisPageList();
    },
    // 清空按钮
    async deleteFile(aab001) {
      // 弹框
      const confirmResult = await this.$confirm('清空人员名单, 是否继续?', '提示', {
        async: false,
        cache: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      // 成功删除为confirm 取消为 cancel
      if (confirmResult != 'confirm') {
        return this.$message.info("已取消删除");
      }

      const {
        data: res
      } = await this.$http.get("deleteFile?aab001=5_" + aab001);
      if (res != "success") {
        return this.$message.error("清空人员名单失败！！！");
      }
      this.$message.success("清空人员名单成功！！！");
      this.showfilelist = false;
      this.redisPageList();
    },
    //确定提交数据
    async insertfile() {
      if (this.total != this.piccnew.num) {
        return this.$message.error("操作失败，上传人员数量与参保人数不一致，请核对信息！");
      }
      // 弹框
      const confirmResult = await this.$confirm('您已经选择补充医疗保险年缴方式进行申报，申报参保人数为 ' + this.piccnew.num + '人，在职参保人数为： ' + this.piccnew.zznum + '人，退休参保人数为： ' + this.piccnew.txnum + '人。' + '保费金额为 ' + this.piccnew.spacec + '"元。请确认以上信息，并进入下一步。', '提示', {
        async: false,
        cache: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      // 成功删除为confirm 取消为 cancel
      if (confirmResult != 'confirm') {
        return this.$message.info("已取消提交");
      }
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let moment = require('moment');
      this.piccnew.spaceb = moment().format("YYYY-MM-DD HH:mm:ss");
      const {data: res} = await this.$http.post("addpiccnew", this.piccnew, { }).catch((err) => {

        this.$message.error("保存失败")
        loading.close();
      })
      if (res.state != "200") {
        loading.close();
        return this.$message.error(res.msg);
      }else {
        loading.close();
        window.sessionStorage.setItem('activePath', "/bcylsljl");
        this.$router.push("/bcylsljl");
        this.reload();
      }

      // this.$message.success("操作成功！！！");

    },
    //返回填写基本信息
    txjbxx() {
      this.steponeShow = true;
      this.steptwoShow = false;
      this.$http.get("deleteFile?aab001=5_" + this.user.aab001);
    },
    //选择档次 计算钱
    getbxblChange() {
      //20241224 lyx add 保险比例
      for (const yearElement of JSON.parse(this.user.column3)) {
        if (this.user.bcylfl == yearElement.id) {
          this.piccnew.bxbl= yearElement.text
        }
      }
      //20241224 lyx add 保险比例
      this.piccnew.num =  parseInt(this.piccnew.zznum) + parseInt(this.piccnew.txnum)
      let qian = this.piccnew.bxbl;
      this.piccnew.spacec = (qian * Number(this.piccnew.zznum)) + (qian * Number(this.piccnew.txnum));
    },
    //输入人员数量时计算应缴钱数
    getspacee(num) {
      if(this.piccnew.bxbl === ''){
        return this.$message.error("请选择缴费标准！");
      }
      else {
        this.piccnew.num = parseInt(this.piccnew.zznum) + parseInt(this.piccnew.txnum)
        let qian = this.piccnew.bxbl;
        this.piccnew.spacec = (qian * Number(this.piccnew.zznum)) + (qian * Number(this.piccnew.txnum));
      }
    },
    //判断是否办理
    async sfbl() {

      let moment = require('moment');
      var formData = new FormData()
      formData.append('aab001', this.user.aab001);
      formData.append('timeaction', '' + moment().startOf('year').format('YYYY-MM-DD'));
      formData.append('timeend', '' + moment().endOf('year').format('YYYY-MM-DD'));
      formData.append('term', '5');
      // 调用post请求
      const {
        data: res
      } = await this.$http.post("sfbl", formData, {}, {
      });

      if (res.sfblCount > 0) {

        if (this.$route.params.id == null) {
          this.steponeShow = false;
          this.steptwoShow = false;
          this.yjblShow = true;
        } else {
          this.piccnew.spacea = this.$route.params.id;
          this.steponeShow = true;
          this.yjblShow = false;
        }


      } else {
        this.steponeShow = true;
        this.yjblShow = false;
        this.piccnew.spacea = this.$route.params.id;
      }

    },
    //获取选中数据
    getTemplateRow(index, row) {
      this.updateuser.usertype = '0' + (index + 1);
      this.updateuser.column1 = row.ejfl + '  ' + row.fy;
      this.buttontype = 'success';
      this.buttonstate = '已选择';
    },
    //获取选中补充医疗报销比例数据
    geylbxblRow(index, row) {
      this.bcylbxlx = row.bxbl;
      if (index == 0) {
        this.zzfy = 260;
      }
      if (index == 1) {
        this.zzfy = 380;

      }

      this.piccnew.spacec = (this.zzfy * this.piccnew.zznum) ;
      this.piccnew.num = Number(this.piccnew.zznum);
      this.piccnew.bxbl = row.bxbl;
    },
    //确定选择行业类别
    gethylb() {
      this.innerVisible = false;
    },
    //确定选择报销比例类型
    getylbxbl() {
      this.ylbxblVisible = false;
    },
    //提交单位信息维护
    async submitForm(formName) {
      // if (this.updateuser.column1 === undefined) {
      //     this.$message({
      //         showClose: true,
      //         message: "请选择行业类型",
      //         type: 'warning',
      //         customClass: 'mzindex'
      //     });
      //     return;
      // }
      this.$refs[formName].validate(async valid => {
        // console.log(valid);
        if (!valid) return;
        // 发起请求
        let moment = require('moment');
        this.updateuser.rqtime = moment().format("YYYY-MM-DD HH:mm:ss");
        this.updateuser.raddress = this.updateuser.dsfj;
        const {
          data: res
        } = await this.$http.post("updatePiccuser", this.updateuser);
        if (res.result != "success") {
          return this.$message.error("操作失败！！！");
        }
        this.$message.success("单位信息维护修改成功！！！");

        // window.sessionStorage.setItem("user", JSON.stringify(res.user)); // session 放置
        this.resetSetItem('user', JSON.stringify(res.user));
        //隐藏
        this.dialogFormVisible = false;
        this.reload();
      })
    },
    //下载人员名单模板(补充医疗)
    downloadMb() {
      const link = document.createElement('a')
      // download属性
      link.setAttribute('download', "人员名单模板.xls")
      // href链接
      link.setAttribute('href', "/file/%E4%BA%BA%E5%91%98%E5%90%8D%E5%8D%95%E6%A8%A1%E6%9D%BF%EF%BC%88%E8%A1%A5%E5%85%85%E5%8C%BB%E7%96%97%EF%BC%89.xls")

      // 自执行点击事件
      link.click()

    },

    //返回首页
    gohome() {
      window.sessionStorage.setItem('activePath', "/welcome");
      this.$router.push("/welcome");
      this.reload();
    }
    ,formatAmount(amount) {
      return Number(amount || 0).toLocaleString('zh-CN');
    }
    ,getStatusTagType(status) {
      const statusMap = {
        '在职': 'success',
        '退休': 'info',
        '离职': 'warning'
      };
      return statusMap[status] || '';
    }

  }
};
</script>
<style lang="less" scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;

  .header-content {
    display: flex;
    align-items: center;
    gap: 12px;

    .header-icon {
      font-size: 28px;
      color: #409EFF;
    }

    .header-title {
      font-size: 24px;
      font-weight: 600;
      color: #303133;
      margin: 0;
    }
  }

  .progress-status {
    .el-tag {
      border-radius: 12px;
      padding: 0px 16px;
      font-weight: 500;
    }
  }
}


.custom-steps {
  padding: 30px 50px 10px;

  /deep/ .el-step__head {
    &.is-process {
      .el-step__icon {
        color: #C0C4CC;
      }
    }
  }

  /deep/ .el-step__title {
    font-size: 16px;
    font-weight: 500;

    &.is-process {
      color: #C0C4CC;
    }
  }

  /deep/ .el-step__description {
    color: #909399;
    font-size: 13px;
  }
}

.notice-alert,
.upload-alert {
  border-radius: 8px;

  /deep/ .el-alert__title {
    font-size: 14px;
    line-height: 1.5;
  }
}

.basic-info-form {
  padding: 10px 40px 40px;

  .info-section {
    margin-bottom: 40px;

    .section-title {
      font-size: 18px;
      font-weight: 600;
      color: #303133;
      margin: 0 0 10px;
      padding-bottom: 12px;
      border-bottom: 2px solid #f0f2f5;
      display: flex;
      align-items: center;
      gap: 8px;

      i {
        color: #409EFF;
      }
    }

    .info-grid {
      .info-item {
        margin-bottom: 10px;

        .info-label {
          font-size: 14px;
          color: #606266;
          margin-bottom: 8px;
          font-weight: 500;
        }

        .info-value {
          font-size: 16px;
          color: #303133;
          padding: 12px 16px;
          background: #f8f9fa;
          border-radius: 8px;
          border: 1px solid #e4e7ed;

          &.highlight {
            color: #409EFF;
            font-weight: 500;
            border-color: #409EFF;
            background: rgba(64, 158, 255, 0.05);
          }
        }
      }
    }
  }

  .premium-standard {
    .premium-options {
      .premium-radio-group {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        margin-top: 8px;

        .premium-option {
          flex: 1;
          min-width: 200px;

          .custom-radio {
            width: 100%;

            /deep/ .el-radio__input {
              margin-right: 12px;
            }

            /deep/ .el-radio__label {
              width: 100%;
            }

            .option-content {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 16px 20px;
              background: #f8f9fa;
              border: 2px solid #e4e7ed;
              border-radius: 8px;
              transition: all 0.3s;

              .option-amount {
                font-size: 16px;
                font-weight: 600;
                color: #303133;
              }

              .option-tip {
                font-size: 12px;
                color: #909399;
                background: #e4e7ed;
                padding: 2px 8px;
                border-radius: 10px;
              }
            }

            &:hover .option-content {
              border-color: #c0c4cc;
              background: #f0f2f5;
            }
          }

          /deep/ .el-radio__input.is-checked + .el-radio__label .option-content {
            border-color: #409EFF;
            background: rgba(64, 158, 255, 0.1);
            box-shadow: 0 2px 12px rgba(64, 158, 255, 0.1);
          }
        }
      }

      .select-prompt {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #e6a23c;
        font-size: 14px;
        margin-top: 8px;
      }
    }
  }

  .personnel-section {

    .number-input-group {
      .input-label {
        font-size: 14px;
        color: #606266;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        gap: 6px;
        font-weight: 500;

        i {
          color: #409EFF;
        }
      }

      .personnel-input {
        width: 100%;

        /deep/ .el-input__inner {
          height: 48px;
          border-radius: 8px;
          font-size: 16px;
          padding: 0 16px;
          border: 2px solid #e4e7ed;
          transition: border-color 0.3s;

          &:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
          }
        }
      }
    }
  }

  .calculation-results {
    .result-card {
      margin-top: 10px;
      background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
      border-radius: 12px;
      padding: 24px;
      border: 1px solid #e4e7ed;

      .result-header {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 10px;

        i {
          color: #67C23A;
        }
      }

      .result-grid {
        .result-item {
          justify-content: space-between;
          display: flex;
          align-items: center;

          .result-label {
            font-size: 14px;
            color: #606266;
            margin-bottom: 8px;
          }

          .result-value {
            font-size: 32px;
            font-weight: 700;

            &.total-person {
              color: #409EFF;
            }

            &.total-amount {
              color: #67C23A;
            }
          }
        }
      }

      .amount-breakdown {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px dashed #dcdfe6;

        .breakdown-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 4px 0;
          font-size: 14px;
          color: #606266;

          .breakdown-amount {
            font-weight: 600;
            color: #303133;
          }
        }
      }
    }
  }
}

.action-buttons {
  text-align: center;
  padding: 10px;

  .next-step-btn {
    padding: 16px 48px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 25px;
    background: linear-gradient(135deg, #409EFF, #67C23A);
    border: none;
    transition: all 0.3s;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(64, 158, 255, 0.3);
    }

    &:disabled {
      background: #c0c4cc;
      transform: none;
      box-shadow: none;
      cursor: not-allowed;
    }
  }
}

.upload-section {
  padding: 0 40px 40px;

  .upload-actions {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 30px 0;

    .upload-btn {
      padding: 16px 32px;
      font-size: 16px;
      border-radius: 8px;
      background: linear-gradient(135deg, #409EFF, #67C23A);
      border: none;

      /deep/ .el-icon-upload2 {
        margin-right: 8px;
      }
    }

    .action-buttons-group {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;

      .template-btn {
        background: #67C23A;
        border-color: #67C23A;
        color: white;
      }

      .help-btn {
        background: #909399;
        border-color: #909399;
        color: white;
      }

      .clear-btn {
        background: #f56c6c;
        border-color: #f56c6c;
        color: white;
      }

      .back-btn {
        background: #e6a23c;
        border-color: #e6a23c;
        color: white;
      }
    }
  }

  .upload-stats {
    display: flex;
    gap: 30px;
    margin-top: 20px;

    .stat-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 20px;
      border-radius: 8px;
      font-size: 14px;

      &.success {
        background: rgba(103, 194, 58, 0.1);
        color: #67C23A;
        border: 1px solid rgba(103, 194, 58, 0.3);
      }

      &.error {
        background: rgba(245, 108, 108, 0.1);
        color: #f56c6c;
        border: 1px solid rgba(245, 108, 108, 0.3);
      }

      .stat-label {
        font-weight: 500;
      }

      .stat-value {
        font-weight: 700;
        font-size: 16px;
      }
    }
  }
}

.personnel-list-section,
.error-list-section {
  padding: 0 40px 40px;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .section-title {
      font-size: 18px;
      font-weight: 600;
      color: #303133;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 8px;

      i {
        color: #409EFF;
      }

      &.error-title i {
        color: #f56c6c;
      }

      .subtitle {
        font-size: 14px;
        font-weight: normal;
        color: #909399;
        margin-left: 8px;
      }
    }

    .personnel-search {
      width: 300px;

      /deep/ .el-input__inner {
        border-radius: 20px;
        padding-left: 40px;
      }
    }
  }
}

.personnel-table,
.error-table {
  margin-bottom: 20px;

  /deep/ .el-table__header {
    th {
      background: #f8f9fa;
      color: #303133;
      font-weight: 600;
    }
  }

  /deep/ .el-table__body {
    tr:hover > td {
      background-color: #f5f7fa !important;
    }
  }
}

.serial-number {
  font-weight: 600;
  color: #409EFF;
}

.error-serial {
  font-weight: 600;
  color: #f56c6c;
}

.error-reason {
  color: #f56c6c;
  font-size: 13px;
}

.pagination-custom {
  margin-top: 20px;
  text-align: right;

  /deep/ .el-pagination__total {
    font-weight: 500;
  }
}

.submit-section {
  padding: 40px;
  border-top: 1px solid #f0f0f0;

  .summary-alert {
    margin-bottom: 30px;

    /deep/ .el-alert__content {
      p {
        margin: 0;
        line-height: 1.6;
      }
    }
  }

  .submit-buttons {
    text-align: center;

    .submit-btn {
      padding: 16px 48px;
      font-size: 16px;
      font-weight: 500;
      border-radius: 25px;
      background: linear-gradient(135deg, #67C23A, #85ce61);
      border: none;
      transition: all 0.3s;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(103, 194, 58, 0.3);
      }

      &:disabled {
        background: #c0c4cc;
        transform: none;
        box-shadow: none;
        cursor: not-allowed;
      }
    }

    .count-warning {
      margin-top: 15px;
      color: #e6a23c;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
    }
  }
}

.upload-help-dialog {
  /deep/ .el-dialog__body {
    padding: 30px;

    .help-content {
      .help-step,
      .help-tips {
        margin-bottom: 30px;

        h4 {
          font-size: 16px;
          font-weight: 600;
          color: #303133;
          margin: 0 0 15px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        p {
          margin: 8px 0;
          color: #606266;
          line-height: 1.6;
          padding-left: 24px;
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .insurance-apply-container {
    padding: 16px;
  }

  .apply-card {
    &.step-one,
    &.step-two {
      margin: 0 16px;
    }
  }

  .card-header,
  .basic-info-form,
  .upload-section,
  .personnel-list-section,
  .error-list-section,
  .submit-section {
    padding-left: 24px;
    padding-right: 24px;
  }
}

@media (max-width: 768px) {
  .card-header {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;

    .header-title {
      font-size: 20px;
    }
  }

  .custom-steps {
    padding: 20px;

    /deep/ .el-step {
      .el-step__title {
        font-size: 14px;
      }
    }
  }

  .premium-radio-group {
    flex-direction: column;

    .premium-option {
      min-width: 100% !important;
    }
  }

  .section-header {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start !important;

    .personnel-search {
      width: 100% !important;
    }
  }

  .action-buttons-group {
    flex-direction: column;

    .el-button {
      width: 100%;
    }
  }

  .upload-stats {
    flex-direction: column;
  }
}
.premium-options {
  .premium-radio-group {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;

    .premium-option {
      flex: 1;
      min-width: 200px;

      .custom-radio {
        width: 100%;

        /deep/ .el-radio__input {
          margin-right: 12px;
        }

        /deep/ .el-radio__label {
          width: 100%;
          display: block;
        }
        /deep/ .el-radio__inner {
          display: none;
        }

        .option-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 20px;
          background: #f8f9fa;
          border: 2px solid #e4e7ed;
          border-radius: 8px;
          transition: all 0.3s;

          .option-amount {
            font-size: 16px;
            font-weight: 600;
            color: #303133;
          }

          .option-tip {
            font-size: 12px;
            color: #909399;
            background: #e4e7ed;
            padding: 2px 8px;
            border-radius: 10px;
          }
        }

        &:hover .option-content {
          border-color: #c0c4cc;
          background: #f0f2f5;
        }
      }

      /deep/ .el-radio__input.is-checked + .el-radio__label .option-content {
        border-color: #409EFF;
        background: rgba(64, 158, 255, 0.1);
        box-shadow: 0 2px 12px rgba(64, 158, 255, 0.1);
      }
    }
  }

  .select-prompt {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #e6a23c;
    font-size: 14px;
    margin-top: 8px;
  }
}
</style>
